<button     type    =   "button" 
            class   =   "btn btn-outline-secondary mr-3" 
            (click) =   "create()" 
            *ngIf   =   "!isInState('create')"
            translate>site.action.create</button>
<br>



<help-alert text = "help.page.site.field" info = "help.info" description = "help.page.site.description"></help-alert>

<div *ngIf="_site_detail" class="card">
    
      <div class="card-header">
        <span translate>site.name.info</span>
    </div>

    <div class="card-body">
                    
        <mat-form-field class = "full-width">
            <mat-label translate>site.field.name</mat-label>
            <input [(ngModel)]="_site_detail.name" matInput required>
        </mat-form-field>

        <br>

        <ng-container *ngIf="operation == 'update'">
            
            <mat-form-field class = "full-width">
                <mat-label translate>site.field.siteCode</mat-label>
                <input [(ngModel)]="_site_detail.siteCode" matInput disabled>
            </mat-form-field>
            <br>

        </ng-container>

        <mat-form-field class = "full-width">
            <mat-label translate>site.field.type</mat-label>
            <input [(ngModel)]="_site_detail.type" matInput>
        </mat-form-field>

        <br>
    
        <mat-form-field class = "full-width">
            <mat-label translate>site.field.address</mat-label>
            <input [(ngModel)]="_site_detail.address" matInput required>
        </mat-form-field>

        <br>
    
        <mat-form-field class = "full-width">
            <mat-label translate>site.field.zipcode</mat-label>
            <input [(ngModel)]="_site_detail.zipCode" matInput required>
        </mat-form-field>

        <br>
    
        <mat-form-field class = "full-width">
            <mat-label translate>site.field.latitude</mat-label>
            <input [(ngModel)]="_site_detail.latitude" matInput required>
        </mat-form-field>

        <br>
    
        <mat-form-field class = "full-width">
            <mat-label translate>site.field.longitude</mat-label>
            <input [(ngModel)]="_site_detail.longitude" matInput required>
        </mat-form-field>

        <br>

        <place-autocomplete #autocompleteManager    
                            [preselect]     =   "{'id': _site_detail.placeId, 'name': _site_detail.placeName}"
                            (placeChange)   =   "placeChanged($event)"></place-autocomplete>
       

        <mat-form-field class = "full-width">
            <mat-label translate>site.field.email</mat-label>
            <input [(ngModel)]="_site_detail.email" matInput>
        </mat-form-field>

        <br>
    
        <mat-form-field class = "full-width">
            <mat-label translate>site.field.phone</mat-label>
            <input [(ngModel)]="_site_detail.phone" matInput>
        </mat-form-field>
        
        <br>

        <mat-checkbox [(ngModel)]="advanced">
            <span translate>site.field.advanced</span>
        </mat-checkbox>

        <br>

        <ng-container *ngIf="advanced">

            <mat-form-field class = "full-width">
                <mat-label translate>site.field.monNotifyEmail</mat-label>
                <input [(ngModel)]="_site_detail.monNotifyEmail" matInput>
            </mat-form-field>

            <br>

            <mat-form-field class = "full-width">
                <mat-label translate>site.field.sessionTime</mat-label>
                <input [(ngModel)]="_site_detail.sessionTime" matInput>
            </mat-form-field>
            
        </ng-container>
        
        <br>

        <ng-container *ngIf="_site_detail && _site_detail.id">

            <progress-radio #progressManager        
                        [site]          =   "_site_detail"
                        class           =   "d-block mt-2"></progress-radio>

        </ng-container>

        <br>

        <mat-checkbox [(ngModel)]="_site_detail.enabled" class = "full-width">
            <span translate>site.field.enable</span>
        </mat-checkbox>

    </div>

    <div class="card-footer">

        <ng-container *ngIf="operation == 'create' && savedSiteDetail && savedSiteDetail.id">
            <button class="btn btn-outline-danger mr-3" (click) = "cancel()" translate>site.action.cancel</button>
        </ng-container>
        
        <button class="btn btn-outline-secondary mr-3" (click) = "update()" translate>site.action.save</button>

        <ng-container *ngIf="isQuickCreateEnabled() && operation == 'create'">
            <button type="button" class="btn btn-outline-secondary mr-3" (click) = "quick()" translate>stepper.action.create</button>
        </ng-container>
        

    </div>
</div>